module.exports = __webpack_public_path__ + "img/incoHotAc.da10e21d.png";